module.exports = __webpack_public_path__ + "img/popup-18-black.dc56729a.png";